var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLickLoop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.85,6 C12.01,6 11.2166667,6.32666667 10.6508333,6.8925 L6.55,10.5325 C6.17666667,10.9058333 5.68083333,11.11 5.15,11.11 C4.05916667,11.11 3.1725,10.2291667 3.1725,9.13833333 C3.1725,8.0475 4.05916667,7.16666667 5.15,7.16666667 C5.68083333,7.16666667 6.17666667,7.37083333 6.57333333,7.7675 L7.2325,8.35083333 L8.11333333,7.56916667 L7.37833333,6.92166667 C6.78333333,6.32666667 5.99,6 5.15,6 C3.41166667,6 2,7.41166667 2,9.13833333 C2,10.865 3.41166667,12.2766667 5.15,12.2766667 C5.99,12.2766667 6.78333333,11.95 7.34916667,11.3841667 L11.45,7.74416667 C11.8233333,7.37083333 12.3191667,7.16666667 12.85,7.16666667 C13.9408333,7.16666667 14.8275,8.0475 14.8275,9.13833333 C14.8275,10.2291667 13.9408333,11.11 12.85,11.11 C12.325,11.11 11.8233333,10.9058333 11.4266667,10.5091667 L10.7616667,9.92 L9.88083333,10.7016667 L10.6216667,11.355 C11.2166667,11.9441667 12.0041667,12.2708333 12.85,12.2708333 C14.5883333,12.2708333 16,10.865 16,9.1325 C16,7.4 14.5883333,6 12.85,6 Z",
    id: "lick-loop_svg__path-lick-loop"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lick-loop_svg__\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lick-loop_svg__\\u97F3\\u9891\\u7F16\\u8F91",
    transform: "translate(-8.000000, -344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lick-loop_svg__\\u7F16\\u7EC4-3",
    transform: "translate(0.000000, 313.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lick-loop_svg__groove-pattern-1",
    transform: "translate(8.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lick-loop_svg__\\u5FAA\\u73AFloop\\u5907\\u4EFD",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "lick-loop_svg__\\u77E9\\u5F62",
    fill: "#F2055B",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "lick-loop_svg__mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lick-loop_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "lick-loop_svg__icon/places/all_inclusive_24px",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#lick-loop_svg__path-lick-loop"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLickLoop);
export default __webpack_public_path__ + "static/media/lick-loop.a1c75ab5.svg";
export { ForwardRef as ReactComponent };